import { render } from "./FollowerUserItem.vue?vue&type=template&id=31f95cf7"
import script from "./FollowerUserItem.vue?vue&type=script&lang=ts"
export * from "./FollowerUserItem.vue?vue&type=script&lang=ts"
script.render = render

export default script